import script from "./MindMapHome.vue?vue&type=script&setup=true&lang=js"
export * from "./MindMapHome.vue?vue&type=script&setup=true&lang=js"

import "./MindMapHome.vue?vue&type=style&index=0&id=57248419&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57248419"]])

export default __exports__